import { TradingModel } from 'consts/tradingModel';

export const tradingModelOptions = [
  { label: 'All', value: '' },
  { label: 'Plays', value: TradingModel.PLAY },
  { label: 'Impressions', value: TradingModel.IMPRESSION },
];
